module.exports = {
  BOH_THRESHOLDS_EDIT_REQUEST: 'BOH_THRESHOLDS_EDIT_REQUEST',
  BOH_THRESHOLDS_EDIT_SUCCESS: 'BOH_THRESHOLDS_EDIT_SUCCESS',
  BOH_THRESHOLDS_EDIT_FAILURE: 'BOH_THRESHOLDS_EDIT_FAILURE',
};
